import { writable } from "svelte/store";

export const unit = writable("");
export const vehicle = writable("");
export const media = writable("");
export const space = writable("");
